import { render, staticRenderFns } from "./comment-input.vue?vue&type=template&id=6822733e&"
import script from "./comment-input.vue?vue&type=script&lang=js&"
export * from "./comment-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports